// Redux
import { useDispatch, useSelector } from 'react-redux';
// Slices
import { setQueryArt } from '../../app/features/artSlice';
// Hooks
import { useGallery } from '../../hooks/useGallery';
// Icons
import { IoMdSearch } from 'react-icons/io';
// Utils
import { isTokenExpired } from '../../utils/isTokenExpired';
import { updateToken } from '../../utils/updateToken';
// Styles
import './ArtSearchBar.css';
import { useTranslation } from 'react-i18next';

const ArtSearchBar = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { getGalleryDataSocket } = useGallery();

  const { queryArt } = useSelector((state) => state.art);

  const allArtSources = [
    'NAGUS',
    'METMUSEUM',
    'DPLA',
    'DIGITALNZ',
    'RIJKSMUSEUM',
    'HARVARDMUSEUM',
    'COOPERMUSEUM',
  ];

  const searchData = async (query) => {
    if (query?.length > 0) {
      if (isTokenExpired(localStorage.expires_in)){
        await updateToken();
      }
      await getGalleryDataSocket(
        query,
        1,
        '',
        '',
        allArtSources,
        '',
        false,
        false,
        false,
        ''
      );
    }
  };

  return (
    <form
      className='metasearchBarContainer'
      onSubmit={(e) => {
        e.preventDefault();
        searchData(queryArt);
      }}
    >
      <input
        placeholder={t('Do a art search')}
        className='metasearchBar'
        type='text'
        value={queryArt}
        onChange={(e) => dispatch(setQueryArt(e.target.value))}
      ></input>
      <button className='metasearchButton' type='submit'>
        <p>{t('Search')}</p>
        <IoMdSearch />
      </button>
    </form>
  );
};

export default ArtSearchBar;
